import { render, staticRenderFns } from "./about_admin.vue?vue&type=template&id=30678047&"
import script from "./about_admin.vue?vue&type=script&lang=js&"
export * from "./about_admin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports